export default {
	searchMonth: '', // moment().format('YYYY-MM'),
	plants: [],
	plantCd: '',
	resultList: [],

	dayCols: [],
	searchUserId: '',
	searchUserNm: '',
	groups: {
		currentPage: 0,
		pageUnit: 10,
		totalSize: 0
	}
};
